<div>
  <button
    type="button"
    (click)="loggedInUser && voterListModal.show()"
    class="btn btn-sm waves-effect"
    [ngClass]="{
      'btn-primary': config.type === 'upvote',
      'btn-danger': config.type === 'downvote'
    }"
  >
    <div style="display: inline-block">
      <i
        class="icofont"
        [ngClass]="{
          'icofont-circled-up': config.type === 'upvote',
          'icofont-circled-down': config.type === 'downvote'
        }"
      ></i>
      <span *ngIf="config.type === 'upvote'">
        {{ discussion.upVoteCount }} {{ config.type }}d
      </span>
      <span *ngIf="config.type === 'downvote'">
        {{ discussion.downVoteCount }} {{ config.type }}d
      </span>
    </div>
  </button>

  <!-- Voters-members-modal -->
  <voter-list-modal
    #voterListModal
    [discussion]="discussion"
    [limit]="limit"
    [config]="config"
    [hideFooter]="true"
  >
  </voter-list-modal>
  <!-- Voters-members-modal -->
</div>
